import { useCallback, useEffect, useState } from 'react'
import { useToast } from '../contexts/ToastContext'
import { copyToClipboard } from '../utils/referral'
/**
 * Copy state for the referral link, shared by every copy affordance.
 * Returns to its resting state on its own after a few seconds.
 */
export function useCopyReferralLink(url: string) {
  const { showToast } = useToast()
  const [copied, setCopied] = useState(false)
  const copy = useCallback(async () => {
    const ok = await copyToClipboard(url)
    if (!ok) {
      showToast('We could not copy the link. Please copy it manually.', 'error')
      return
    }
    setCopied(true)
    showToast('Referral link copied', 'success', 2500)
  }, [showToast, url])
  useEffect(() => {
    if (!copied) return
    const timer = setTimeout(() => setCopied(false), 2500)
    return () => clearTimeout(timer)
  }, [copied])
  return {
    copied,
    copy,
  }
}
